<template>
  <div class="LadderScheme">
    <span class="label">阶梯方案(配置单位:月):</span>
    <el-table
      v-if="tableDataList.length > 0"
      :data="tableDataList"
    >
      <el-table-column
        v-for="(item, index) of tableTileList"
        :key="index"
        :prop="item.prop"
        :label="item.title"
      >
      </el-table-column>
    </el-table>
    <span v-else>--</span>
  </div>
</template>

<script>
export default {
  props: {
    ladderSchemeList: {
      type: Array,
      default: () => [],
    },
    titleList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    ladderSchemeList: {
      handler() {
        this.initTableData()
      },
      deep: true,
    },
  },
  data() {
    return {
      tableTileList: [],
      tableDataList: [],
    }
  },
  created() {
    this.initTableData()
  },
  methods: {
    initTableData() {
      if (this.ladderSchemeList.length <= 0) return
      this.tableDataList = []
      this.tableTileList = []
      // 给默认值
      this.tableDataList = new Array(this.titleList.length - 1).fill(null).map(() => { return {} })
      // 设置表头
      this.tableTileList.push({
        title: '阶梯',
        prop: 'rowTitle',
      })
      for (let i = 0; i < this.ladderSchemeList.length; i++) {
        this.tableTileList.push({
          title: `第${i + 1}阶梯`,
          prop: `labber${i}`,
        })
      }

      // 获取表单值
      for (let i = 0; i < this.titleList.length - 1; i++) {
        this.tableDataList[i].rowTitle = this.titleList[i + 1].label
        this.ladderSchemeList.forEach((item, index) => {
          this.tableDataList[i][`labber${index}`] = this.ladderSchemeList[index][this.titleList[i + 1].value]
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.LadderScheme {
  width: 50%;
  .label {
    color: #333333;
  }
}
</style>
